/* eslint-disable import/prefer-default-export */
import React from "react";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { loginApiRequest } from "../../authConfig";
import { useEffect } from "react";

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export const SignInButton = () => {
  const { instance } = useMsal();
  const { t } = useTranslation();

  const handleLogin = (loginType) => {
    if (loginType === "redirect") {
      instance.loginRedirect(loginApiRequest).catch(async (e) => {
        console.log(e);
      });
    }
  };
  return (
    <span onClick={() => handleLogin("redirect")}>
      <a
        // className="btn btn-success"
        style={{ width: "100%" }}
      >
        <span> {t("signin")}</span>
      </a>
    </span>
  );
};
